import React, { useState, useEffect, createRef } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import Typography from "@mui/material/Typography";
import TableContainer from "@mui/material/TableContainer";
import Container from "@mui/material/Container";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import { API_URL } from "../utils/constants";
import { useLoginResult } from "../State/LoginResultContext";
import { useErrorRenderer } from "../Hooks/useErrorRenderer";
import { showToast } from "../utils/toast";
import { useNavigate } from "react-router-dom";
import "../Event/OrgEvents.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { useMemo } from 'react';


const options = {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric",
};

const columns = [
  { id: "fullName", label: "Full Name", minWidth: 150, align: "center", format: (value) => value, },
  { id: "organization", label: "Organization", minWidth: 150, align: "center", format: (value) => value, },
  { id: "subscription", label: "Subscription", minWidth: 120, align: "center", format: (value) => value || "Free trial", },
  { id: "subscriptionActive", label: "Active", minWidth: 100, align: "center", format: (value) => value, },
  { id: "phoneNumber", label: "Phone", minWidth: 150, align: "center", format: (value) => value, },
  { id: "email", label: "Email", minWidth: 200, align: "center", format: (value) => value, },
  {
    id: "createdDate",
    label: "Created",
    minWidth: 170,
    align: "center",
    format: (value) => (`${new Date(value).toLocaleDateString(undefined, options)}  ${new Date(value).toLocaleTimeString("en-US")}`),
  },
];

function UsersTable({ loginResults }) {
  const navigate = useNavigate();
  const [message, setMessage, isError, setIsError, resetErrorState] =
      useErrorRenderer();

  const email = loginResults.email;
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = React.useState(false);
  const [orderBy, setOrderBy] = React.useState("desc");
    const [rows, setRows] = useState([]);
    const [meta, setMeta] = useState({
      users: [],
      page: 1,
      pages: 0,
      total: 0,
      per_page: 0,
      order_by: "desc",
    });

  useEffect(() => {
    fetchUsers(1);
  }, [page]);

  const handleOnBlur = async () => {
    await fetchUsers(1);
}

const handleOnSearch = async (e) => {
    e.preventDefault();
    await fetchUsers(1);

  };

  const handleViewUsage = (userId) => {
      navigate(`/user-usage/${userId}`);
  }


   const handleDelete = async (userId) => {
  
      try {
        const response = await fetch(API_URL + `/users/deleteUser/${userId}`, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${loginResults.token}`,
          },
        });
  
        const data = await response.json();
        if (response.status === 200) {
          setRows(rows.filter((user) => user.id !== userId));
        } else {
          setMessage(data.message);
          setIsError(true);
          resetErrorState();
        }
      } catch (error) {
        setMessage(error.message);
        setIsError(true);
        resetErrorState();
      }
    };

  const fetchUsers = async (p) => {
    try {
        const currentPage = p || page;
        setLoading(true);
      const response = await fetch(`${API_URL}/users?page=${currentPage}&limit=${rowsPerPage}&order_by=${orderBy}&search=${searchTerm}`,
        {
          method: "GET", 
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${loginResults.token}`, 
          },
        }
      );
      const data = await response.json();

      setLoading(false);
      if (response.status === 200) {
        setMeta(data);
        setRows(data.users);
      } else {
        setMessage(data.message);
        setIsError(true);
        resetErrorState();
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };


  return (
    <div className="p-6">
      {/* <TextField
        label="Search by Organization"
        variant="outlined"
        fullWidth
        onChange={(e) => setSearchTerm(e.target.value)}
        onBlur={handleOnBlur}
        className="mb-4"
      /> */}



      <Paper sx={{ width: "100%", overflow: "hidden" }}>

        
      <Container sx={{ 
            width: "100%", 
            overflow: "hidden", 
            display: "flex", 
            justifyContent: "space-between",
            alignItems: "center" // Optional: Align items vertically
        }}>
            <Typography>Organization:</Typography>
                <TextField
                  type="text"
                  label="Search by Organization"
                    variant="outlined"
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onBlur={handleOnBlur}
                    className="mb-4"
                />
            
                <Typography>Created At:</Typography>
                <select
                  value={orderBy}
                  onChange={(e) => setOrderBy(e.target.value)}
                >
                  <option value={"desc"}>Descending</option>
                  <option value={"asc"}>Ascending</option>
                </select>
            
                <button onClick={handleOnSearch}
                className="w-fit right-0 bg-[#5701AE] text-white text-[13px] rounded-lg py-1 px-3 font-semibold shadow-[0_0_0_1px_rgba(255,255,255,0.2)] hover:bg-[#7c4dff] transition-colors"
                >submit</button>
                             
        </Container>
        <TableContainer sx={{ maxHeight: 440 }}>
          <Table stickyHeader className="hidden md:table w-full border-collapse min-w-[600px] atkinson-font">
            <TableHead>

              <TableRow >
                {columns.map((column) => (
                  <TableCell key={column.id} align={column.align} sx={{ fontWeight: "bold" }}
                  className="bg-[#d9d9d9] text-black font-bold p-3 text-left text-[20px]">
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
              {loading ? (
                              <TableBody><TableRow><TableCell>Loading...</TableCell></TableRow></TableBody>
                            ) : (
                              <TableBody>
                                {rows.length > 0
                                  ? rows.map((row, index) => {
                                    const isEvenRow = index % 2 === 0;
                                    return (
                                      <TableRow
                                        hover
                                        role="checkbox"
                                        tabIndex={-1}
                                        key={row.id}
                                        className={isEvenRow ? "bg-[#d2d2d2]" : "bg-[#919191]"}
                                      >
                                        {columns.map((column) => {
                                          const value = row[column.id];
                                          
                                          return (
                                            <TableCell key={column.id} align={column.align}
                                            className="p-4 text-black text-[20px] align-middle tracking-[-0.41px]"
                                            >
                                           
                                              {column.id === "subscriptionActive" ? (value ? "Yes" : "No") : column.format(value)}
                                            </TableCell>
                                          );
                                        })}
              
                                        <TableCell align="center">
                                          <button
                                            className="w-fit right-0 bg-[#5701AE] text-white text-[13px] rounded-lg py-1 px-3 font-semibold shadow-[0_0_0_1px_rgba(255,255,255,0.2)] hover:bg-[#7c4dff] transition-colors"
                                            onClick={(e) => handleViewUsage(row.id)}
                                          >
                                            usage
                                          </button>
                                        </TableCell>
                                        <TableCell align="center">
                                            <button
                                            className="w-fit right-0 bg-[#5701AE] text-white text-[13px] rounded-lg py-1 px-3 font-semibold shadow-[0_0_0_1px_rgba(255,255,255,0.2)] hover:bg-[#7c4dff] transition-colors"
                                              onClick={(e) => {
                                                if (
                                                  window.confirm(
                                                    "Are you sure you wish to delete this user with associated data ?"
                                                  )
                                                )
                                                  handleDelete(row.id);
                                              }}
                                            >
                                              delete
                                            </button>
                                          </TableCell>
                                       
                                      </TableRow>
                                    );
                                  })
                                  : <TableRow><TableCell>{""}</TableCell></TableRow>}
                      </TableBody>
                    )}
           
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[15, 25, 50]}
          component="div"
          count={meta.total}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}           

        />
      </Paper>
    </div>
  );
}



const ProtectedPage = () => {
  const { loginResults } = useLoginResult();

  const isAuthorized = useMemo(() => {
    if (!loginResults || !loginResults.email) return false;
    return ["nsikan.sly@gmail.com", "gregmena@hotmail.com"].includes(loginResults.email);
  }, [loginResults]);

  if (!isAuthorized) {
    return <h2>You are unauthorized to view this page.</h2>;
  }

  return (
    <div>
      <UsersTable loginResults={loginResults} />
    </div>
  );
};

export default ProtectedPage;
